import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { AlertBoxActionState } from "web_myplann/NotificationCenter/EventAlert/alertActionStateSchema";
import { formatAlertDate } from "web_myplann/NotificationCenter/EventAlert/formatAlertDate";
import type { ParsedAlertActionState } from "web_myplann/NotificationCenter/EventAlert/parseAlertActionStates";

const actionStateResource: Record<
	AlertBoxActionState,
	typeof Resources.EventAlert.ActionState.sent
> = {
	Sent: Resources.EventAlert.ActionState.sent,
	Opened: Resources.EventAlert.ActionState.lastOpened,
};

export const getActionSubtext = (
	parsed: ParsedAlertActionState | undefined,
	t: ReturnType<typeof useResource>["t"],
): string | undefined => {
	if (!parsed) {
		return undefined;
	}

	return t(actionStateResource[parsed.state], {
		date: formatAlertDate(parsed.performedAt),
	});
};
